export function getParcelPath(
  property: Partial<{ country: string; stateAbbr: string; county?: string }>
) {
  return [
    '/US', // property.country
    property.stateAbbr,
    property.county
      ?.replace('County', '')
      .replace('Parish', '')
      .trim()
      .replace(/[^a-z| ]/gi, ''),
  ]
    .filter((v) => v)
    .join('/')
    .toLowerCase()
    .replace(/ /g, '-')
}
